module.exports = __webpack_public_path__ + "Flama-ThinItalic.ttf?13478df16a806453c53f219852944126";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-ThinItalic.ttf
// module id = 934
// module chunks = 0